<template>
  <div class="login-container">
    <div class="login-form">
      <img class="logo" src="../assets/logo.png">
      <!-- 登录表单 -->
      <form id="login_form">
        <van-cell-group>
          <van-field
            v-model="username"
            label="用户名"
            icon="clear"
            placeholder="请输入用户名"
            required
            @click-icon="username = ''"
          />

          <van-field
            v-model="password"
            type="password"
            label="密码"
            icon="clear"
            placeholder="请输入密码"
            required
            @click-icon="password = ''"
            :error-message="loginError"
            v-on:focus="loginError=''"
          />
        </van-cell-group>
      </form>
      <button class="login submit" @click="Jump('login')">登&nbsp;&nbsp;&nbsp;&nbsp;录</button>
    </div>
  </div>
</template>
<script type="text/javascript">
  export default{
    data() {
      return {
        username:'',
        password:'',
        loginError:'',
      }
    },
    methods: {
      //按钮点击的时候进行验证 =》 提交 =》 存本地 =》 本地提取 =》 完成登录
      Jump: function(show) {
        this.$api.post('/api/authorizations', {
          username: this.username,
          password: this.password,
        }, data => {
          window.localStorage.token  = data.access_token;
          this.$router.replace({path: 'employee'})
        },error=>{
          if(error.status === 410){
            this.loginError = error.data.message
          }
        })
      },
    },
    created () {
      window.localStorage.token  = "";
    }
  }
</script>
<style type="text/css" scoped>
  .login-container{
    height: 100%;
    width: 100%;
  }
  .login-form{
    width: 90%;
    margin: 30% auto 40px auto;
    border-radius: 5px;
  }
  .login-form .logo{
    width: 110%;
    margin-left: -3%;
    margin-bottom: 100px;
  }
  .submit{
    width: 250px;
    height: 40px;
    display: block;
    margin: 0 auto;
    border-radius: 5px;
    font-size: 20px;
    font-weight: bold;
    color: #ffffff;
    outline: none;
  }
  .submit:active{
    background: #FC7171;
  }
  .login{
    margin-top: 30px;
    background-color: #6CDFED;
    border: 1px solid #6CDFED;
  }
  button:disabled{
    background-color: #B9ABAB;
    border: none;
  }
  input:-webkit-autofill {
    -webkit-box-shadow: 0 0 0px 1000px white inset;
    border: 1px solid #CCC!important;
    height: 27px!important;
    line-height: 27px!important;
    border-radius: 0 4px 4px 0;
  }
</style>



// WEBPACK FOOTER //
// src/pages/login.vue